export const ROOT_GROUP_ID = -1
export const RECENT_GROUP_ID = -2
export const FAVORITE_GROUP_ID = -3
